import { FlatList, type ViewStyle } from "react-native";
import { List } from "react-native-paper";
import type { Style } from "react-native-paper/lib/typescript/components/List/utils";
import EmptyState, { type EmptyViewProps } from "./EmptyView";

export type ListItem = {
	id: string;
	title: string;
	description?: string;
	customLeft?: (p: {
		color: string;
		style: Style;
	}) => React.ReactNode;
	customRight?: (p: {
		color: string;
		style?: Style;
	}) => React.ReactNode;
	emptyState?: EmptyViewProps;
	style?: ViewStyle;
};

type Props = {
	items: ListItem[];
	selectedId?: string;
	onSelect?: (id: string) => void;
	emptyState?: EmptyViewProps;
};

const ItemList = ({ items, onSelect, emptyState }: Props) => {
	return (
		<FlatList
			data={items}
			keyExtractor={(item) => item.id}
			contentContainerStyle={{ paddingBottom: 16 }}
			ListEmptyComponent={emptyState ? <EmptyState {...emptyState} /> : null}
			renderItem={({ item }) => (
				<List.Item
					title={item.title}
					description={item.description}
					descriptionNumberOfLines={2}
					onPress={onSelect ? () => onSelect(item.id) : undefined}
					left={item.customLeft ? (p) => item.customLeft?.(p) : undefined}
					right={item.customRight ? (p) => item.customRight?.(p) : undefined}
					style={item.style}
				/>
			)}
		/>
	);
};

export default ItemList;
